import axios from "axios";

export default {
  async create(formData) {
    return axios.post(`/rent-objects`, formData);
  },
  async copy(formData) {
    return axios.post(`/rent-objects/copy-paste`, formData);
  },
  async paste(formData) {
    return axios.post(`/rent-objects/copy-paste`, formData);
  },
  async findOne({id}) {
    return axios.get(`/rent-objects/${id}`);
  },
  async findByIdForBookingCalendar({id}) {
    return axios.get(`/rent-objects/${id}/minimal`);
  },
  async findAll() {
    return axios.get(`/rent-objects`);
  },
  async findAllWithChannel() {
    return axios.get(`/rent-objects/channels`);
  },
  async search(searchString) {
    return axios.get(`/rent-objects/admin/search-results`+searchString);
  },
  async delete({ id }) {
    return axios.delete(`/rent-objects/${id}`);
  },
  async update({ id, formData }) {
    return axios.put(`/rent-objects/${id}`, formData);
  },
  async updateOrder(formData) {
    return axios.put(`/rent-objects/${formData.id}/order`, formData);
  },
  async statistics(formData) {
    return axios.get(`/rent-objects/${formData.id}/statistics/${formData.year}/${formData.month}`);
  }
};
